import _classCallCheck from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { track, onAnalyticsUnload } from '../analytics';
import { onUserActivity } from '@analytics/activity-utils';
import { WebsiteEvents } from '../constants/events';
var HEARTBEAT_INACTIVITY_TIMEOUT = 10000; // 10 seconds

var HEARTBEAT_INTERVAL = 10000; // 10 seconds

export var defaultHeartbeatOptions = {
  inactivityTimeout: HEARTBEAT_INACTIVITY_TIMEOUT,
  interval: HEARTBEAT_INTERVAL
};

var HeartbeatSender = /*#__PURE__*/function () {
  function HeartbeatSender(interval) {
    _classCallCheck(this, HeartbeatSender);

    this.interval = interval;

    _defineProperty(this, "timer", void 0);
  }

  _createClass(HeartbeatSender, [{
    key: "start",
    value: function start() {
      this.timer = setInterval(function () {
        return track(WebsiteEvents.HEARTBEAT);
      }, this.interval);
    }
  }, {
    key: "resume",
    value: function resume() {
      track(WebsiteEvents.HEARTBEAT);
      this.start();
    }
  }, {
    key: "stop",
    value: function stop() {
      clearInterval(this.timer);
    }
  }]);

  return HeartbeatSender;
}();
/**
 * This tracker is used to send heartbeat events to the analytics while the user is active.
 * It's dispatched every 10 seconds by default (configurable via options.interval).
 * It's stopped when the user is inactive for 10 seconds (configurable via options.inactivityTimeout).
 * It's resumed when the user becomes active again.
 */


export var heartbeatEventTracker = function heartbeatEventTracker(options) {
  options = _objectSpread(_objectSpread({}, defaultHeartbeatOptions), options);
  var sender = new HeartbeatSender(options.interval);
  var activityMonitor = onUserActivity({
    timeout: options.inactivityTimeout,
    onWakeUp: sender.resume.bind(sender),
    onIdle: sender.stop.bind(sender)
  });
  sender.start();
  onAnalyticsUnload(function () {
    sender.stop();
    activityMonitor.disable();
  });
};